import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from '../../material/material.module';
import { SharedModule } from '../../shared.module';

@Component({
  templateUrl: './cancel-confirm-dialog.component.html',
  standalone: false,
  //imports: [SharedModule],
  styles: [],
})
export class CancelConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: CancelConfirmParams) {}

  get message(): string {
    return this.data?.message;
  }
}

export type CancelConfirmParams = {
  message: string;
};
